import React from "react";
import {Animate} from "react-move";
import {easeQuadIn} from "d3-ease";
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class AnimatedProgressProvider extends React.Component {
    interval = undefined;

    state = {
        isAnimated: false
    };

    static defaultProps = {
        valueStart: 0
    };

    componentDidMount() {
        this.setState({
            isAnimated: !this.state.isAnimated
        });
    }

    componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    render() {
        return (
            <Animate
                start={() => ({
                    value: this.props.valueStart
                })}
                update={() => ({
                    value: [
                        this.state.isAnimated ? this.props.valueEnd : this.props.valueStart
                    ],
                    timing: {
                        duration: this.props.duration * 1000,
                        ease: this.props.easingFunction
                    }
                })}
            >
                {({value}) => this.props.children(value)}
            </Animate>
        );
    }
}

const CircleProgress = ({progress, strokeWidth = 5, size , ...props}) => {

    return (
        <div className="metric-circle" {...props} style={size ? {width: size, height:size} : undefined}>
            <AnimatedProgressProvider
                valueStart={0}
                valueEnd={progress}
                duration={1.5}
                easingFunction={easeQuadIn}>
                {value => {
                    const roundedValue = Math.round(value);
                    return (
                        <CircularProgressbar
                            value={value}
                            strokeWidth={strokeWidth ?? 5}
                            styles={buildStyles({
                                trailColor: '#D3D8DD',
                                pathColor: '#FFB946',
                                pathTransition: "none",
                                strokeLinecap: 'butt',
                            })}
                        />
                    );
                }}
            </AnimatedProgressProvider>
            {props.children && (
                <div className="circle-progress-text">
                    {props.children}
                </div>
            )}
        </div>
    )
}

export default CircleProgress;

const SimpleCircleProgress = (props) => {

    let size = props.size || '25px'
    return (
        <div className={`flex flex-col items-stretch ${props.className || ''}`} style={{width: size, height:size}}>
            <AnimatedProgressProvider
                valueStart={0}
                valueEnd={props.value}
                duration={1.5}
                easingFunction={easeQuadIn}>
                {value => {
                    const roundedValue = Math.round(value);
                    return (
                        <CircularProgressbar
                            value={value}
                            className="flex-1"
                            strokeWidth={props.stroke || 4}
                            styles={buildStyles({
                                trailColor: TB.config('color.gray'),
                                pathColor: TB.config('color.orange'),
                                pathTransition: "none",
                                strokeLinecap: 'butt',
                            })}
                        />
                    );
                }}
            </AnimatedProgressProvider>
        </div>
    )
}

export {
    SimpleCircleProgress
}